import React, { memo } from 'react';
import { Box } from '@rsos/components/capstone/base';
import ThemeControl from '../../common/ThemeControl';
import Settings from './Settings/index';

interface SettingsControlProps {
  path: string;
}

function areEqual(
  prevProps: SettingsControlProps,
  nextProps: SettingsControlProps,
) {
  return prevProps.path === nextProps.path;
}

function SettingsControl({ path }: SettingsControlProps): React.ReactElement {
  const isEmergencyData =
    path === '/home' ||
    path === '/irp-home' ||
    path === '/query-interface' ||
    path === '/irp-query-interface';

  return (
    <Box horizontal>
      {isEmergencyData ? (
        <>
          <Settings path={path} themeName={undefined} />
        </>
      ) : (
        <ThemeControl path={path} data-name="navigation-theme-control" />
      )}
    </Box>
  );
}

export default memo(SettingsControl, areEqual);
